// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sexImg[data-v-404da26c] {\n  width: 16px !important;\n  height: 16px !important;\n  margin-left: 2px;\n}", ""]);
// Exports
module.exports = exports;
